import React from "react";
import "../../src/App.css";

function ContactUs() {
  return (
    <div className="page-content">
      <h1>Contact Us</h1>
      <p>
        We’d love to hear from you! Whether you have questions, feedback, or
        need support, feel free to reach out.
      </p>
      <h2>General Inquiries</h2>
      <p>
        Email: <a href="mailto:info@multido.com">info@multido.com</a>
      </p>
      <h2>Support</h2>
      <p>
        Email: <a href="mailto:support@multido.com">support@multido.com</a>
      </p>
      <h2>Feedback</h2>
      <p>
        Email: <a href="mailto:feedback@multido.com">feedback@multido.com</a>
      </p>
      <h2>Accessibility Concerns</h2>
      <p>
        Email:{" "}
        <a href="mailto:accessibility@multido.com">accessibility@multido.com</a>
      </p>
    </div>
  );
}

export default ContactUs;
